<template>
  <f7-page name="new-contact">
    <div class="card-container">
      <div class="local-subheader">
        <div class="user-management-icon"></div>
        <div class="title">{{ $t('newContact') }}</div>
      </div>

      <NewContactForm />
    </div>
  </f7-page>
</template>

<script>
import NewContactForm from '@/components/Contact/NewContactPopup/index.vue';

export default {
  components: { NewContactForm },
  methods: {
    goBack() {
      // si hay historial, volver; si no, navega a la lista/gestión que te interese
      const r = this.$f7.views.main.router;
      if (r.history && r.history.length > 1) r.back();
      else r.navigate('/users'); // o la ruta que corresponda a tu listado
    },
  },
};
</script>

<style scoped>
.local-subheader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0px 16px;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  color: var(--Primary-Blue-70, #04509f);
  border-radius: 6px;
  margin: 8px 8px 16px;
}
.local-subheader .title {
  font-weight: 600;
}

.card-container {
  background-color: white; /* Fondo blanco */
  padding: 20px; /* Relleno dentro del card */
  border-radius: 10px; /* Esquinas redondeadas suaves */
  /* Sombra (shadow) */
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.3);
  margin-top: 15px; /* Pequeño margen superior para separarlo de la barra azul */
  margin-bottom: 15px; /* Margen inferior */
}

.icon-contact {
  /* La URL que proporcionaste */
  background-image: url('@/static/icons/iconfinder-new-contat.svg');

  /* Asegura que la imagen no se repita */
  background-repeat: no-repeat;

  /* Ajusta el tamaño de la imagen dentro del contenedor (opcional) */
  background-size: contain; /* o '24px 24px' si quieres un tamaño fijo */

  /* Establece las dimensiones del contenedor del icono */
  width: 45px; /* Ajusta el tamaño según tu icono */
  height: 45px; /* Ajusta el tamaño según tu icono */

  /* Centra la imagen si el tamaño del contenedor es mayor */
  background-position: center;
}
</style>
